import MobileCarousel from '../../src/js/mobile-carousel';

export default class PartnerBenefits {
  constructor() {
    const $els = document.querySelectorAll('.js-benefits-carousel');
    $els.forEach($el => new MobileCarousel($el));
  }
}
